import { Component, Input, ChangeDetectorRef, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ErrorLoggerService, NotificationService } from 'app/services';
import { TranslateService } from '@ngx-translate/core';
import { ListSectionHandler } from '../../entities/shared/list.section';
import { IKuiTableCol } from 'app/key-ui';
import * as Bluebird from 'bluebird';

@Component({
    selector: 'key-admin-list-editor',
    templateUrl: './list-editor.component.html',
    styleUrls: ['./list-editor.component.scss'],
})
export class AdminListEditorComponent implements OnChanges {

    @Input() entity: any;
    @Input() handler: ListSectionHandler;
    @Input() editable: boolean;

    @Output() onEditing = new EventEmitter<boolean>();
    @Output() onSaving = new EventEmitter<any>();
    @Output() onSaved = new EventEmitter<any>();

    errorMessage: string;

    rows: any[];
    cols: IKuiTableCol[] = [];
    selectedRow: any;

    page = 1;
    total = 1;
    limit = 30;
    delay = 0;

    constructor(
        private error: ErrorLoggerService,
        private notify: NotificationService,
        public i18n: TranslateService,
        private ref: ChangeDetectorRef
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.handler && this.handler) {
            this.load(true).catch(err => this.showError(err));
        }
    }

    async load(bypassCache?: boolean): Promise<void> {
        this.errorMessage = null;
        if (this.entity) {
            await Bluebird.delay(this.delay);
            this.cols = await this.handler.getColumns();
            const result = await this.handler.getItems(this.entity, (this.page - 1) * this.limit, this.limit, bypassCache);
            this.rows = result.items;
            this.total = result.count;
        }
        this.ref.markForCheck();
    }

    onRowSelected(row: any) {
        this.selectedRow = row;
        this.ref.markForCheck();
    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error && this.notify.translateError(error);
        this.ref.markForCheck();

    }

    onPageChanged(page: number) {
        this.page = page;
        this.load().catch(err => this.showError(err));
    }


    addClicked() {
        this.handler.actionClicked('add', []).then(() => {
            this.delay = 500;
            return this.load(true).catch(err => this.showError(err)).finally(() => { this.delay = 0; });
        });
    }

    deleteClicked() {
        if (this.selectedRow) {
            this.handler.actionClicked('delete', [this.selectedRow]).then(() => {
                this.delay = 500;
                return this.load(true).catch(err => this.showError(err)).finally(() => { this.delay = 0; });
            });
        }
    }

}
